import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=353ee84a&scoped=true&"
import script from "./IconInfo.vue?vue&type=script&lang=ts&"
export * from "./IconInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ee84a",
  null
  
)

export default component.exports